import { render, staticRenderFns } from "./StackedCardsOverlay.vue?vue&type=template&id=465aa643&scoped=true"
import script from "./StackedCardsOverlay.vue?vue&type=script&lang=js"
export * from "./StackedCardsOverlay.vue?vue&type=script&lang=js"
import style0 from "./StackedCardsOverlay.vue?vue&type=style&index=0&id=465aa643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465aa643",
  null
  
)

export default component.exports